import React, {useEffect, useState} from "react";
import {Typography, Box, List, ListItem} from "@mui/material";
import {makeStyles} from "@mui/styles";
import { NavLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    cardWrapper: {
        border: '1px solid #BBBBBB',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
    },
	cardImage: {
		position: 'relative',
		minHeight: '300px',
		overflow: 'hidden',
	},
	cardImageEl: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		objectFit: 'cover'
	},
	header: {
		minHeight: '53px',
		marginBottom: '20px'
	},
	content: {
        padding: '20px 40px 30px 40px',
		display: 'flex',
		flexDirection: 'column',
		flex: '1 1 auto'
    },
	infoList: {
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
		marginBottom: '30px',
		padding: '0px'
	},
	counter: {
		display: 'block',
		fontWeight: 800,
		fontSize: '20px',
		marginTop: '5px',
	},
	star: {
		color: '#00A9D9',
		display: 'inline-block',
		marginLeft: '7px',
		fontSize: '10px',
		position: 'relative',
		top: '-3px'
	},
	progressGroup: {
		width: '100%',
		maxWidth: '200px',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginBottom: '40px',
		padding: '0px',
		flex: '1 1 auto'
	},
	progress: {
		width: '100%',
		height: '10px',
		borderRadius: '5px',
		backgroundColor: '#E1E1E1',
		overflow: 'hidden'
	},
	progressFill: {
		display: 'block',
		width: '0%',
		height: '10px',
		borderRadius: '5px',
		position: 'relative',
		left: 0,
		backgroundColor: '#00A9D9',
		transition: 'all 0.8s linear'
	},
	button: {
        padding: ' 4px 10px',
		width: '100%',
		display: 'flex !important',
		justifyContent: 'center',
		backgroundColor: '#00A9D9',
		textTransform: 'uppercase',
		color: '#fff !important',
		fontWeight: 600,
		borderRadius: '30px',
		marginBottom: '20px',
		fontSize: '14px',
		maxWidth: '250px',
		marginLeft: 'auto',
		marginRight: 'auto',
		textDecoration: 'none',
		lineHeight: '1.75',
		letterSpacing: '0.02857em',
		fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
		'&:last-child': {
			marginBottom: '0px'
		},
		"&:hover": {
			backgroundColor: '#0082A6 !important',
		}
    },
	buttonYellow: {
		backgroundColor: '#e1b724'
	}
}));

const formatLabel = (key) => {
	const words = key.split('_');
	const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
	return formattedWords;
};

const RatingItem = ({ label, value }) => {
	const classes = useStyles();
	const [widthR, setWidthR] = useState(0);

	useEffect(() => {
		setTimeout(() => {
			setWidthR(parseFloat(value) / 5 * 100);
		}, 500)
	}, [value]);

	return (
		<ListItem sx={{ padding: 0, marginBottom: '5px', flexDirection: 'column', alignItems: 'flex-start' }}>
			<Typography variant="label" component="label" sx={{ fontSize: '14px' }}>
				{label}
			</Typography>
			<Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
				<div className={classes.progress}>
					<span className={classes.progressFill} style={{ width: `${widthR}%` }}></span>
				</div>
				<span style={{ display: 'block', textAlign: 'right', flex: '0 0 19px', marginLeft: '10px', whiteSpace: 'nowrap', fontSize: '14px' }}>
					{value !== 0 ? value : '0.0'}
				</span>
			</Box>
		</ListItem>
	)
};
//description
const Card = ({title, shortname, total_reviews, avg, header, ratings}) => {
	const classes = useStyles();

	return (
		<div className={classes.cardWrapper}>
			{header !== null &&
				<div className={classes.cardImage}>
					<img src={header} alt={title} className={classes.cardImageEl}/>
				</div>
			}
			<div className={classes.content}>
				<Box className={classes.header}>
					<Typography variant="h4" component="h3" sx={{textAlign: 'center', fontWeight: '800',textTransform: 'uppercase'}}>
						{title}
					</Typography>
					{/*{description !== null && <Typography variant="h4" component="h4" sx={{textAlign: 'center', textTransform: 'uppercase'}}>{description}</Typography>}*/}
				</Box>
				<List className={classes.infoList}>
					<ListItem sx={{justifyContent: 'center', padding: '10px', borderRight: '1px solid #BBBBBB'}}>
						<Typography
							gutterBottom
							variant="h3"
							component="h4"
							sx={{
								fontSize: '18px',
								margin: 0,
								fontWeight: '300'
							}}
						>
                        	Total Reviews
                        	<span className={classes.counter}>{total_reviews}</span>
                        </Typography>
					</ListItem>
					<ListItem sx={{justifyContent: 'center', padding: '10px'}}>
						<Typography
							variant="h3"
							component="h4"
							sx={{
								fontSize: '18px',
								margin: 0,
								fontWeight: '300'
							}}
						>
							Average Rating
							<span className={classes.counter}>{avg}<span className={classes.star + " fa fa-star"}></span></span>
						</Typography>
					</ListItem>
				</List>
				<List className={classes.progressGroup}>
					{ratings && ratings !== undefined && Object.keys(ratings).map(rating => <RatingItem label={formatLabel(rating)} value={ratings[rating]}/>)}
				</List>
				<Box className={classes.action}>
					<NavLink 
						to={`/ratings/destination/${shortname}`}
						className={`${classes.button} ${total_reviews === 0 ? classes.buttonYellow : ''}`}
					>
						{total_reviews === 0 ?
						'Coming Soon'
						:
                        'READ REVIEWS'
						}
                    </NavLink>
					<NavLink 
						to={`/?tripClass=${shortname}`}
						className={classes.button}
					>
                        DATES & RATES
                    </NavLink>
				</Box>
			</div>
		</div>
	)
};

export {Card};
